






















import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";

@Component
export default class NoAccountMessage extends Vue {
  @Prop({default: true})
  isCardMode: boolean;
}
